import React, { useEffect, useState } from 'react';

import Loader from '../../Loader/Loader';

import { getTokenInfo } from '../../../UseToken';

import { language } from './Language';

import Swal from 'sweetalert2'

import Calendar from '@toast-ui/react-calendar';
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import { api_crud_base, api_crud_route, api_list_route, /*data_interface, endpoints*/ } from './Config';

import {

	reqGET,
	reqPOST,
	/*reqDELETE,
	reqPUT,*/

} from '../../../Utils';

export default function View(props) {

    const [schedueles, setSchedueles] = useState([]);
    const [calendars, setCalendars] = useState([]);
    const [selectedView, setSelectedView] = useState('month');
    const [calendarTitle, setcalendarTitle] = useState('');

    const [isloading, setLoading] = useState(true);
    //const [refresh, setRefresh] = useState(0);

	const [lang, set_lang] = useState('pt');

    var today = new Date()

    var calendar_views = [
        {
            name: language[lang].calendar_month,
            value: 'month'
        }, 
        {
            name: language[lang].calendar_week,
            value: 'week'
        },
        {
            name: language[lang].calendar_day,
            value: 'day'
        }
    ]

    const getDate = (type, start, value, operator) => {
        start = new Date(start);
        type = type.charAt(0).toUpperCase() + type.slice(1);
    
        if (operator === '+') {
            start[`set${type}`](start[`get${type}`]() + value);
        } 
        else {
            start[`set${type}`](start[`get${type}`]() - value);
        }
    
        return start;
    };

    const aux_schedueles = [
        {
            id: '1',
            calendarId: '1',
            title: 'TOAST UI Calendar Study',
            category: 'time',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 3, '+').toISOString()
        },
        {
            id: '2',
            calendarId: '0',
            title: 'Practice',
            category: 'time',
            dueDateClass: '',
            start: getDate('date', today, 1, '+').toISOString(),
            end: getDate('date', today, 1, '+').toISOString(),
            isReadOnly: true
        },
        {
            id: '3',
            calendarId: '0',
            title: 'FE Workshop',
            category: 'allday',
            dueDateClass: '',
            start: getDate('date', today, 2, '-').toISOString(),
            end: getDate('date', today, 1, '-').toISOString(),
            isReadOnly: true
        },
        {
            id: '4',
            calendarId: '0',
            title: 'Report',
            category: 'milestone',
            dueDateClass: '',
            start: today.toISOString(),
            end: getDate('hours', today, 1, '+').toISOString()
        }
    ]

    /*const aux_calendars = [
        {
            id: '0',
            name: 'Pessoal',
            bgColor: '#9e5fff',
            borderColor: '#9e5fff',
            status: true
        },
        {
            id: '1',
            name: 'Formação 1',
            bgColor: '#00a9ff',
            borderColor: '#00a9ff',
            status: true
        }
    ]*/

    const get_events = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => { 
                //setData(res.data); setLoading(false) 
                let aux_schedueles = []
                res.data.forEach((v) => {
                    aux_schedueles.push({
                        id: v.id,
                        companycode: v.info.companycode,
                        calendarId: v.info.calendarId,
                        title: v.info.title,
                        category: v.info.category,
                        dueDateClass: v.info.dueDateClass,
                        start: v.info.start,
                        end: v.info.end,
                        isAllDay: v.info.isAllDay,
                        location: v.info.location,
                        state: v.info.state,
                        raw: v.info.raw,
                        isReadOnly: v.info.isReadOnly
                    })
                })

                setSchedueles(aux_schedueles)
            })
            .catch(() => 404)
    }

    const get_calendars = async () => {
        await reqGET(`${api_crud_base}/calendar/category/${getTokenInfo().companycode}`)
            .then(res => { 
                //setData(res.data); setLoading(false) 
                let aux_calendar = []
                res.data.forEach((v) => {
                    aux_calendar.push({
                        id: v.id,
                        name: v.info.name,
                        bgColor: v.info.bgColor,
                        borderColor: v.info.borderColor,
                        status: v.info.status
                    })
                })

                setCalendars(aux_calendar)
            })
            .catch(() => 404)
    }

    useEffect(() => {
        //const companycode = getTokenInfo().companycode;
        
        set_lang(localStorage.getItem('lang'))

        get_events()
        get_calendars()

        //setSchedueles(aux_schedueles)
        //setCalendars(aux_calendars)
        setcalendarTitle(new Date().toLocaleString(language[localStorage.getItem('lang')].calendar_language, { month: 'long', year: 'numeric' }))
        setLoading(false)
        
        
    }, [props]);

	const max_id_array = (array) => {
		let max_value = Math.max.apply(Math, array.map(function(o) { return o.id; }))

		array.forEach(v => {
			if(v.children && v.children.length > 0) {
				let max_value_2 = max_id_array(v.children)

				if(max_value_2 > max_value)
					max_value = max_value_2
			}
		})

		return max_value
	}

    const addDateScheduel = (e) => {
        const { calendarId, title, start, end, isAllDay, isPrivate, location, state, /*raw*/ } = e;
        const companycode = getTokenInfo().companycode;
        
        let aux_id = max_id_array(schedueles)
        let aux_scheduel = {
            /*id: (aux_id + 1).toString(),*/
            companycode: companycode,
            calendarId: calendarId,
            title: title,
            category: (isAllDay ? 'allday' : 'time'),
            dueDateClass: '',
            start: start._date,
            end: end._date,
            isAllDay: isAllDay,
            location: location,
            state: state,
            //raw: raw ,
            isReadOnly: (isPrivate === 'private' ? true : false)
        }

        // console.log(aux_scheduel)
        // setSchedueles([...schedueles, aux_scheduel])

        // return

        Swal.fire({
            title: 'Novo Registo',
            text: "Tem a certeza que pretende continuar?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        })
        .then((result) => {
            if (result.isConfirmed) {
                reqPOST(api_crud_route(), {id: '', info: aux_scheduel})
                    .then(() => { 
                        aux_schedueles['id'] = (aux_id + 1).toString()
                        setSchedueles([...schedueles, aux_scheduel])
                        //props.history.push(endpoints.list) 
                    })
                    .catch((erro) => {
                        console.log('Problema ao atualizar Registo!: ', erro)
                    })
            }
        })

        
    }

    const editDateScheduel = (e) => {
        const { schedule, changes } = e;

        let aux_scheduel = schedueles.filter(v => v.id === schedule.id)
        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)

        aux_schedueles.push(aux_scheduel[0])
        aux_schedueles.forEach((v) => {
            if(v.id === schedule.id) {
                var obj = changes;
                for(var key in obj) {
                    var value = obj[key];
                    //console.log(key + ": " + value);
                    v[key] = value
                }

            }
        })

        //console.log(aux_schedueles)
        setSchedueles(aux_schedueles)
    }

    const removeDateScheduel = (e) => {
        const { schedule } = e;

        let aux_schedueles = schedueles.filter(v => v.id !== schedule.id)
        setSchedueles(aux_schedueles)
    }

    const myTheme = {
        // Theme object to extends default dark theme.
    };
      
    const myTemplate = {
        milestone(schedule) {
            return `<span style="color:#fff;background-color: ${schedule.bgColor};">${schedule.title}</span>`;
        },
        milestoneTitle() {
            return 'Milestone';
        },
        task: function(schedule) {
            return '#' + schedule.title;
        },
        taskTitle: function() {
            return '<span className="tui-full-calendar-left-content">Tarefa</span>';
        },
        allday(schedule) {
            return `${schedule.title}<i className="fa fa-refresh"></i>`;
        },
        alldayTitle() {
            return language[lang].calendar_allday;
        },
        popupIsAllDay: function() {
            return language[lang].calendar_allday;
        },
        popupStateFree: function() {
            return language[lang].calendar_free;
        },
        popupStateBusy: function() {
            return language[lang].calendar_busy;
        },
        titlePlaceholder: function() {
            return language[lang].calendar_title_placeholder;
        },
        locationPlaceholder: function() {
            return language[lang].calendar_location_placeholder;
        },
        startDatePlaceholder: function() {
            return language[lang].calendar_start_placeholder;
        },
        endDatePlaceholder: function() {
            return language[lang].calendar_end_placeholder;
        },
        popupSave: function() {
            return language[lang].calendar_save;
        },
        popupUpdate: function() {
            return language[lang].calendar_update;
        },
        // popupDetailDate: function(isAllDay, start, end) {
        //     var isSameDate = moment(start).isSame(end);
        //     var endFormat = (isSameDate ? '' : 'YYYY.MM.DD ') + 'hh:mm a';

        //     if (isAllDay) {
        //         return moment(start).format('YYYY.MM.DD') + (isSameDate ? '' : ' - ' + moment(end).format('YYYY.MM.DD'));
        //     }

        //     return (moment(start).format('YYYY.MM.DD hh:mm a') + ' - ' + moment(end).format(endFormat));
        // },
        popupEdit: function() {
            return language[lang].calendar_edit;
        },
        popupDelete: function() {
            return language[lang].calendar_delete;
        }
    }

    /*const calendarOptions = {
        // sort of option properties.
    };*/

    const calendarRef = React.createRef();
    const handleClickButton = (type) => {
        const calendarInstance = calendarRef.current.getInstance();

        if(type === 'today') {
            calendarInstance.today();
        }
        if(type === 'prev') {
            calendarInstance.prev();
        }
        if(type === 'next') {
            calendarInstance.next();
        }

        if(type === 'day') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'week') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }
        if(type === 'month') {
            calendarInstance.changeView(type, true);
            setSelectedView(type)
        }

        if(calendarInstance.getViewName() === 'day') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
        }
        if(calendarInstance.getViewName() === 'week') {
            setcalendarTitle(calendarInstance.getDateRangeStart()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + ' ~ ' + calendarInstance.getDateRangeEnd()._date.toLocaleString(language[lang].calendar_language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })) 
        }
        if(calendarInstance.getViewName() === 'month') {
            setcalendarTitle(calendarInstance.getDate()._date.toLocaleString(language[lang].calendar_language, { month: 'long', year: 'numeric' }))
        }

        //calendarInstance.toggleSchedules('0', true, true)

        //console.log(calendarInstance.getViewName())
        // console.log(calendarInstance.getDate())
        // console.log(calendarInstance.getDate()._date)
        // console.log(calendarInstance.getDate()._date.toLocaleString('default', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }))
    };
    const handleToggleButton = (e) => {
        const { value, dataset } = e.target
        const { status } = dataset

        let toHide = true
        let toHideChild = true
        let render = true

        const calendarInstance = calendarRef.current.getInstance();
        if(value === "all") {
            if(status === 'true') {
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                e.target.dataset.status = false
                toHide = true
            }
            else {
                //document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                e.target.dataset.status = true
                toHide = false
            }

            if(status !== 'true')
                toHideChild = false
            
            calendars.forEach((v) => {
                if(toHide) {
                    document.getElementById('calendar-' + v.id).dataset.status = false
                    // document.getElementById('calendar-' + v.id).removeAttribute('checked')
                    document.getElementById('calendar-' + v.id).checked = false
                    v.status = false
                }
                else {
                    document.getElementById('calendar-' + v.id).dataset.status = true
                    // document.getElementById('calendar-' + v.id).setAttribute('checked', 'checked')
                    document.getElementById('calendar-' + v.id).checked = true
                    v.status = true
                }
    
                calendarInstance.toggleSchedules(v.id, toHideChild, render)
            })
        }
        else {
            if(status === 'true') {
                document.getElementById('calendar-' + value).dataset.status = false
                // document.getElementById('calendar-' + value).removeAttribute('checked')
                document.getElementById('calendar-' + value).checked = false
                toHide = true
            }
            else {
                document.getElementById('calendar-' + value).dataset.status = true
                // document.getElementById('calendar-' + value).setAttribute('checked', 'checked')
                document.getElementById('calendar-' + value).checked = true
                toHide = false
            }

            let allChecked = true
            calendars.forEach((v) => {
                if(document.getElementById('calendar-' + v.id).dataset.status === 'false')
                    allChecked = false
            })

            if(allChecked) {
                document.getElementById('calendar-all').dataset.status = true
                document.getElementById('calendar-all').checked = true
            }
            else {
                document.getElementById('calendar-all').dataset.status = false
                document.getElementById('calendar-all').checked = false

            }

            calendarInstance.toggleSchedules(value, toHide, render)
        }
    }

    return (isloading ?
        
        <Loader />

    :

        <main>
            <div className={`dash-cards dash-cards-calendar header`}>
                <h2 className="dash-title">{language[lang].calendar}</h2>
                <p>{language[lang].calendar}</p>
            </div>
        
            <div className={`dash-cards dash-cards-calendar body`}>
                <div className="container">
                    <div className="card">
                        <div className="card-body d-none">
                            <h2 className="dash-title">
                                {language[lang].calendar}
                            </h2>
                        </div>

                        <div className="card-body">
                            <div className="col-12 d-flex flex-stack my-5 px-5">
                                <div className="flex-1">
                                    <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('prev')} data-action="move-prev">
                                        <i className="bi bi-chevron-left" data-action="move-prev"></i>
                                    </button>
                                    <button type="button" className="btn btn-sm btn-light move-day" onClick={() => handleClickButton('next')} data-action="move-next">
                                        <i className="bi bi-chevron-right" data-action="move-next"></i>
                                    </button>

                                    <button type="button" className="btn btn-sm btn-light move-today ms-3" onClick={() => handleClickButton('today')} data-action="move-today">{language[lang].calendar_today}</button>
                                </div>

                                <div className="flex-1 text-center">
                                    <h3 className="fw-bolder m-0">{calendarTitle}</h3>
                                </div>

                                <div className="flex-1 text-end">
                                    {
                                    calendar_views.map((v, k) => {
                                        return (
                                            <button key={k} type="button" aria-pressed={selectedView === v.value ? "true" : "false"} className={selectedView === v.value ? "btn btn-sm btn-secondary" : "btn btn-sm btn-light"} onClick={() => handleClickButton(v.value)}>{v.name}</button>
                                        )
                                    })
                                    }
                                </div>
                            </div>
                            <div className="col-12 px-5">
                                <div className="row">
                                    <div className="col-2">
                                        <div className="calendars">
                                            <div className="btn-calendars">
                                                <div className="form-check form-check-custom form-check-solid  my-2">
                                                    <input className="form-check-input" type="checkbox" id="calendar-all" defaultChecked="checked" data-status="true" value="all" onClick={handleToggleButton} />
                                                    <label className="form-check-label" htmlFor="calendar-all">
                                                        <strong>{language[lang].calendar_viewall}</strong>
                                                    </label>
                                                </div>
                                                {
                                                calendars.map((v, k) => {
                                                    return (
                                                        <div key={k} className="form-check form-check-custom form-check-solid my-2">
                                                            <input type="radio" className="form-check-input rounded-circle" data-s={v.status} style={{backgroundColor: v.bgColor, borderColor: v.borderColor}} id={'calendar-' + v.id} defaultChecked="checked" data-status="true" value={v.id} onClick={handleToggleButton} />
                                                            <label className="form-check-label" htmlFor={'calendar-' + v.id}>
                                                                {v.name}
                                                            </label>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-10">
                                        <Calendar
                                            ref={calendarRef}
                                            height="auto"
                                            calendars={calendars}
                                            disableDblClick={true}
                                            disableClick={false}
                                            isReadOnly={false}
                                            month={{
                                                startDayOfWeek: 0,
                                                daynames: language[lang].calendar_daynames
                                            }}
                                            schedules={schedueles}
                                            scheduleView
                                            taskView
                                            template={myTemplate}
                                            theme={myTheme}
                                            timezones={[
                                                {
                                                    timezoneName: 'Europe/Lisbon',
                                                    displayLabel: 'GMT+00:00',
                                                    tooltip: 'Lisbon'
                                                }
                                            ]}
                                            useDetailPopup
                                            useCreationPopup
                                            view={selectedView}
                                            week={{
                                                hourStart: 0,
                                                hourEnd: 24,
                                                showTimezoneCollapseButton: true,
                                                timezonesCollapsed: true,
                                                daynames: language[lang].calendar_daynames
                                            }}
                                            onAfterRenderSchedule={() => { }}
                                            onBeforeDeleteSchedule={(e) => {removeDateScheduel(e) }}
                                            onClickDayname={() => { }}
                                            onClickSchedule={() => { }}
                                            onClickTimezonesCollapseBtn={() => { }}
                                            onBeforeUpdateSchedule={(e) => { editDateScheduel(e) }}
                                            onBeforeCreateSchedule={(e) => { addDateScheduel(e) }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    )
}
